import type { RouteLocationAsPathGeneric } from "vue-router"

type QueryParams = Record<string, string | undefined>

export function checkoutPageUrl(productParam: string, queryParams?: QueryParams) {
  let query = ""

  if (queryParams) {
    const filteredQueryParams = filterQueryParams(queryParams)
      .toString()
      .replace(/%2F/g, "/")

    query = filteredQueryParams ? `?${filteredQueryParams}` : ""
  }

  return `/produkter/${productParam}/betaling${query}`
}

function filterQueryParams(
  queryParams?: QueryParams,
): URLSearchParams {
  if (!queryParams) {
    return new URLSearchParams()
  } else {
    const queryParamsToRemove: string[] = []

    for (const param in queryParams) {
      if (
        queryParams[param] === undefined ||
        queryParams[param] === null
      ) {
        queryParamsToRemove.push(param)
      }
    }

    queryParamsToRemove.forEach(param => delete queryParams[param])

    return new URLSearchParams(queryParams as Record<string, string>)
  }
}

/**
 * Generate the frontend path for an article
 * @param productKey The product key
 * @param variantKey The variant key
 * @param subjectTitle The subject title (will be sanitized for URL)
 * @param articleTitle The article title (will be sanitized for URL)
 * @returns The frontend path for the article
 */
export function generateArticlePath(productKey: string | undefined, variantKey: string | undefined, subjectTitle: string | undefined, articleTitle: string | undefined): string {
  const subjectUrlFraction = sanitizeForUrl(subjectTitle)
  const articleUrlFraction = sanitizeForUrl(articleTitle)

  return `/produkter/${productKey}/${variantKey}/${subjectUrlFraction}/${articleUrlFraction}`
}

const FULLSCREEN_QUERY_KEY = "fromFullscreen"

export function isRouteFullscreen(route: RouteLocationAsPathGeneric | undefined) {
  return route?.query?.[FULLSCREEN_QUERY_KEY] === String(true)
}

export function getFullscreenLink<T extends RouteLocationAsPathGeneric | undefined>(route: T, fullScreen: boolean): T {
  return route && {
    ...route,
    query: {
      ...route.query,
      [FULLSCREEN_QUERY_KEY]: String(fullScreen),
    },
  }
}
